var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishListRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.96875V4.8125C0.5 2.625 2.0625 0.75 4.21875 0.40625C5.625 0.15625 7.09375 0.625 8.125 1.65625L8.5 2L8.84375 1.65625C9.875 0.625 11.3438 0.15625 12.75 0.40625C14.9062 0.75 16.5 2.625 16.5 4.8125V4.96875C16.5 6.28125 15.9375 7.53125 15 8.40625L9.34375 13.6875C9.125 13.9062 8.8125 14 8.5 14C8.15625 14 7.84375 13.9062 7.625 13.6875L1.96875 8.40625C1.03125 7.53125 0.5 6.28125 0.5 4.96875Z",
    fill: "#EF3145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListRed);
export default __webpack_public_path__ + "static/media/WishListRed.0432468e559953278cb613162ae1c7a5.svg";
export { ForwardRef as ReactComponent };